
import { Component, Vue, Prop } from 'vue-property-decorator'

@Component({
  components: {},
})
export default class DynamicHiddenInput extends Vue {
  @Prop()
  public min!: any

  @Prop()
  public max!: any

  @Prop()
  public value!: any

  @Prop()
  public id!: string

  @Prop()
  public type!: string

  @Prop({ default: true })
  public hidden!: boolean

  @Prop()
  public isOpenEnded!: boolean

  render(h: any) {
    const attrs: any = {
      id: this.id,
      type: this.type || 'number',
      value: this.value,
      hidden: this.hidden,
    }

    // Only add min/max constraints if not open-ended
    if (!this.isOpenEnded) {
      if (this.min !== undefined) attrs.min = this.min
      if (this.max !== undefined) attrs.max = this.max
    }

    return h('input', {
      attrs,
    })
  }
}
